export const Routes = {
	EnterEmailPageRoute: "EnterEmailPageRoute",
	EmailVerificationPageRoute: "EmailVerificationPageRoute",
	WalletVerificationPageRoute: "WalletVerificationPageRoute",
	RegistrationCompletePageRoute: "RegistrationCompletePageRoute"
}